/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect } from 'react';

import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Label } from "components/Form";
import { Col } from 'components/Grid';
import TagsList3 from "components/TagList3";
import { AttachmentContainer } from './styles';

export default function FilesAttachment({
  idOperation,
  directorApproval = false,
  ...props
}) {
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
  const [wordingFile, setWordingFile] = useState({});
  const [wordingAttachmentFile, setWordingAttachmentFile] = useState({});
  const [idOperationRoot, setIdOperationRoot] = useState(null)
  const [signedDocs, setSignedDocs] = useState([])

  async function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(idOperation)
      .then(response => response.json())
      .then(response => {
        setIdOperationRoot(response?.idOperationRoot)
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  async function handleGetFiles() {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestGetDocuments(idOperationRoot)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });


    fitinsur.requestGetDocuments(idOperationRoot, true)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingAttachmentFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument,
          });
        } else {
          setWordingAttachmentFile({})
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });


    fitinsur.requestAttachAssumptions(idOperationRoot)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setScheduleAssumptionsFile({
            dsTypeDocument: "Schedule",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
    loading.stop();
  }


  async function getSignedDocs() {
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestGetSignedDocuments(idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        if (response.ret_value.length > 0) {



          let allSignedDocs = response.ret_value;
          const hasOrder = allSignedDocs.some(doc => doc.order);

          if (hasOrder) {
            allSignedDocs.sort((a, b) => +a.order - +b.order)
          }

          allSignedDocs = allSignedDocs.filter(doc => doc.documentType && !["Execution"].includes(doc.documentType))

          setSignedDocs(allSignedDocs.map(document => ({
            dsTypeDocument: document.documentType,
            nameDocument: document.documentName,
            idTypeDocument: null,
            nameFile: document.documentName,
            size: null,
            type: null,
            urlLink: document.url,
            idDocument: document.idDocument
          })));
        }
      }).catch((error) => {
        console.error('fitPostFiles - Error:', error);
      });
  }

  useEffect(() => {
    getOperationInfo();
  }, []);

  useEffect(() => {
    if (!props.signedDocs) {
      handleGetFiles()
    } else {
      getSignedDocs()
    }
  }, [idOperationRoot])

  if (directorApproval) {
    return (
      <AttachmentContainer>
        {signedDocs.length || wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile
          || wordingAttachmentFile && wordingAttachmentFile.nameFile ?
          <TagsList3
            tags={[...signedDocs, wordingAttachmentFile, wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
            disableType
            hideTrash={true}
          />
          : ''}
      </AttachmentContainer>
    )
  }

  return (
    <>
      {signedDocs.length || wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile
        || wordingAttachmentFile && wordingAttachmentFile.nameFile ?
        <Col md={12} sm={1} style={{ marginBottom: 20 }}>
          <Label>{props.signedDocs ? "Signed Documents" : "Attachments"}</Label>
          <TagsList3
            tags={[...signedDocs, wordingAttachmentFile, wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
            disableType
            hideTrash={true}
          />
        </Col>
        : ''}
    </>
  );
}